import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useGestaoUsuarios } from '../context/GestaoUsuariosProvider';
import { Users, UserCheck, UserX, Shield, Eye, Settings, Plus, Building } from 'lucide-react';

const DashboardUsuarios = () => {
  const { carregarUsuarios, carregarEstatisticasPopulacao, obterEstatisticas, loading } = useGestaoUsuarios();
  const stats = obterEstatisticas();

  useEffect(() => {
    carregarUsuarios();
    carregarEstatisticasPopulacao();
  }, [carregarUsuarios, carregarEstatisticasPopulacao]);

  if (loading) {
    return (
      <div className="gestao-usuarios dashboard-full-container">
        <div className="dashboard-loading">
          <div className="loading-spinner"></div>
          <p>Carregando dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="gestao-usuarios dashboard-full-container">
      <div className="dashboard-header">
        <div className="header-content">
          <h1>
            <Users size={32} />
            Dashboard de Usuários
          </h1>
          <p>Visão geral dos usuários do sistema</p>
        </div>
        <div className="header-actions">
          <Link to="/gestao-usuarios/cadastro" className="button primary">
            <Plus size={16} />
            Novo Usuário
          </Link>
        </div>
      </div>

      <div className="dashboard-content">
        {/* Cards de Estatísticas */}
        <div className="stats-grid">
          <div className="stat-card total">
            <div className="stat-icon">
              <Users size={24} />
            </div>
            <div className="stat-content">
              <h3>Total de Usuários</h3>
              <div className="stat-number">{stats.total}</div>
              <div className="stat-label">usuários cadastrados</div>
            </div>
          </div>

          <div className="stat-card ativo">
            <div className="stat-icon">
              <UserCheck size={24} />
            </div>
            <div className="stat-content">
              <h3>Usuários Ativos</h3>
              <div className="stat-number">{stats.ativos}</div>
              <div className="stat-label">usuários ativos</div>
            </div>
          </div>

          <div className="stat-card inativo">
            <div className="stat-icon">
              <UserX size={24} />
            </div>
            <div className="stat-content">
              <h3>Usuários Inativos</h3>
              <div className="stat-number">{stats.inativos}</div>
              <div className="stat-label">usuários inativos</div>
            </div>
          </div>

          <div className="stat-card admin">
            <div className="stat-icon">
              <Shield size={24} />
            </div>
            <div className="stat-content">
              <h3>Administradores</h3>
              <div className="stat-number">{stats.administradores}</div>
              <div className="stat-label">administradores</div>
            </div>
          </div>

          <div className="stat-card colaboradores">
            <div className="stat-icon">
              <Building size={24} />
            </div>
            <div className="stat-content">
              <h3>Colaboradores</h3>
              <div className="stat-number">{stats.colaboradores || 0}</div>
              <div className="stat-label">colaboradores</div>
            </div>
          </div>

          <div className="stat-card populacao">
            <div className="stat-icon">
              <Users size={24} />
            </div>
            <div className="stat-content">
              <h3>População</h3>
              <div className="stat-number">{stats.populacao || 0}</div>
              <div className="stat-label">usuários app/whatsapp</div>
            </div>
          </div>
        </div>

        {/* Cards de Níveis de Acesso */}
        <div className="access-levels-grid">
          <div className="access-card admin">
            <div className="access-icon">
              <Shield size={20} />
            </div>
            <div className="access-content">
              <h4>Administradores</h4>
              <div className="access-count">{stats.administradores}</div>
              <p>Acesso total ao sistema</p>
            </div>
          </div>

          <div className="access-card operador">
            <div className="access-icon">
              <Settings size={20} />
            </div>
            <div className="access-content">
              <h4>Operadores</h4>
              <div className="access-count">{stats.operadores}</div>
              <p>Acesso a módulos específicos</p>
            </div>
          </div>

          <div className="access-card visualizador">
            <div className="access-icon">
              <Eye size={20} />
            </div>
            <div className="access-content">
              <h4>Visualizadores</h4>
              <div className="access-count">{stats.visualizadores}</div>
              <p>Apenas visualização</p>
            </div>
          </div>
        </div>

        {/* Ações Rápidas */}
        <div className="quick-actions">
          <h3>Ações Rápidas</h3>
          <div className="actions-grid">
            <Link to="/gestao-usuarios" className="action-card">
              <Users size={24} />
              <h4>Gerenciar Usuários</h4>
              <p>Visualizar e editar usuários</p>
            </Link>

            <Link to="/gestao-usuarios/cadastro" className="action-card">
              <Plus size={24} />
              <h4>Novo Usuário</h4>
              <p>Cadastrar novo usuário</p>
            </Link>

            <Link to="/gestao-usuarios/colaboradores" className="action-card">
              <Building size={24} />
              <h4>Gerenciar Colaboradores</h4>
              <p>Visualizar e editar colaboradores</p>
            </Link>

            <Link to="/gestao-usuarios/colaboradores/cadastro" className="action-card">
              <Plus size={24} />
              <h4>Novo Colaborador</h4>
              <p>Cadastrar novo colaborador</p>
            </Link>

            <Link to="/gestao-usuarios/populacao" className="action-card">
              <Users size={24} />
              <h4>População de Usuários</h4>
              <p>Usuários do app e WhatsApp</p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardUsuarios;